import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ArticleList from '../elements/article_list'
import BlogList from '../elements/blog_list'
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Blog extends Component {

  render() {
    return (
        <div>
            <div className="container mit blog">
                <div className="container_message" >
                    <div className="content_text_title">Articles + Industry News</div>
                    <div className="content_text">
                    Learn about the latest trends and perspectives on diverse topics from world-wide industry including wellness and longevity research, medical innovation, and technology advancements that are reshaping the landscape of personalized wellness today.
                    </div> 
                    {/*<Button className="button_learn_more" intent="primary" icon="chevron-right">Learn More</Button>*/}
                </div>
            </div>
            
        <ArticleList/>
        <BlogList/>

        </div>
    );
  }
}

export default Blog;